const EditableLink = props => {
  return props.output;
};

export default EditableLink;
